import { Icon, merge, Stack, Text } from '@fluentui/react';
import { Player } from '@lottiefiles/react-lottie-player';
import React, { useCallback, useMemo, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AccessType, useAuth } from '../../../contexts/authContext';
import { ResponsiveSize, useResponsiveSize } from '../../../contexts/responsiveContext';
import { newId } from '../../../helpers';

const MenuItem = (props) => {

    const {
        badgeId = undefined,
        badgeLabel = undefined,
        customStyles = {},
        id = undefined,
        json = undefined,
        label = undefined,
        onClick = () => null,
        path = undefined,
        src = undefined
    } = props;

    const { accessType } = useAuth();
    const { responsiveSize } = useResponsiveSize();
    const location = useLocation();
    const navigate = useNavigate();
    const playerRef = useRef();

    const isActive = useMemo(() => {
        return location.pathname === path;
    }, [location.pathname, path]);

    const styles = useMemo(
        () => {
            let styles = {
                badge: {
                    root: {
                        alignItems: "end",
                        background: "red",
                        borderRadius: 3,
                        color: "white",
                        display: "flex",
                        fontSize: 16,
                        fontWeight: 700,
                        height: 20,
                        lineHeight: "16px",
                        marginRight: 26,
                        paddingLeft: 5,
                        paddingRight: 5,
                    }
                },
                icon: {
                    image: { margin: "auto" },
                    root: { width: 40 },
                },
                image: { image: { width: 33 } },
                inner: {
                    root: {
                        alignItems: "center",
                        gap: 15,
                        height: 63,
                        paddingLeft: isActive ? 22 : 24,
                        width: "100%"
                    }
                },
                label: {
                    root: {
                        color: "black",
                        cursor: "pointer",
                        fontSize: 16,
                        fontWeight: 700,
                        lineHeight: "15px",
                    }
                },
                outer: {
                    root: {
                        alignItems: "center",
                        borderBottom: "1px solid #DADADA",
                        borderLeft: isActive ? "2px solid red" : "none",
                    }
                },
            };

            if (responsiveSize >= ResponsiveSize.medium)
                styles = merge(styles, {
                    badge: {
                        root: {
                            marginBottom: 10,
                            marginRight: 0
                        }
                    },
                    image: { image: { width: 40 } },
                    inner: {
                        root: {
                            alignItems: "end",

                            gap: 4,
                            height: "unset",
                            paddingLeft: 0,
                        }
                    },
                    label: {
                        root: {
                            borderBottom: isActive ? "2px solid red" : "none",
                            fontWeight: isActive ? 600 : 400,
                            marginBottom: 10,
                            whiteSpace: "pre-wrap",
                            selectors: {
                                ":hover, :active, :focus": {
                                    color: "black",
                                    textDecoration: "none",
                                }
                            }
                        }
                    },
                    outer: {
                        root: {
                            alignItems: "end",
                            borderBottom: "none",
                            borderLeft: "none",
                        }
                    },
                });

            merge(styles, customStyles);

            return styles;
        },
        [customStyles, isActive, responsiveSize]
    );

    const onMouseEnter = useCallback(() => playerRef.current?.play(), []);
    const onMouseLeave = useCallback(() => playerRef.current?.stop(), []);
    const redirect = useCallback(() => {
        navigate(path, { state: newId() }); // State utilis� dans Mes Documents (pour forcer un render m�me lorsqu'on se trouve d�j� sur la page)
        onClick();
    }, [navigate, onClick, path]);

    return <Stack horizontal horizontalAlign="space-between" styles={styles.outer}>
        <Stack horizontal onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} styles={styles.inner}>
            {!!json && <Player ref={playerRef} src={json} style={{ width: 40 }} />}
            {!!src && <Icon imageProps={{ src, styles: styles.icon }} />}
            <Text id={id} onClick={redirect} styles={styles.label}>{label}</Text>
        </Stack>
        {!!badgeLabel && (accessType === AccessType.client) && <Text id={badgeId} styles={styles.badge}>{badgeLabel}</Text>}
    </Stack>;

};

export default MenuItem;